export const vestingABI = [
    {
        inputs: [
            {
                internalType: 'contract ISpoolOwner',
                name: 'spoolOwnable',
                type: 'address',
            },
            {
                internalType: 'contract IERC20Mintable',
                name: '_voSPOOL',
                type: 'address',
            },
            { internalType: 'contract IERC20', name: '_spool', type: 'address' },
            { internalType: 'uint256', name: '_vestingDuration', type: 'uint256' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    { internalType: 'address', name: 'prev', type: 'address' },
                    { internalType: 'address', name: 'next', type: 'address' },
                ],
                indexed: true,
                internalType: 'struct Member',
                name: 'members',
                type: 'tuple',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Transferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Vested',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'duration',
                type: 'uint256',
            },
        ],
        name: 'VestingInitialized',
        type: 'event',
    },
    {
        inputs: [],
        name: 'begin',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'claim',
        outputs: [{ internalType: 'uint256', name: 'vestedAmount', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'end',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getClaim',
        outputs: [{ internalType: 'uint256', name: 'vestedAmount', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address[]', name: 'members', type: 'address[]' },
            { internalType: 'uint192[]', name: 'amounts', type: 'uint192[]' },
        ],
        name: 'setVests',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'spoolToken',
        outputs: [{ internalType: 'contract IERC20', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'start',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'total',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address', name: 'prev', type: 'address' },
                    { internalType: 'address', name: 'next', type: 'address' },
                ],
                internalType: 'struct Member',
                name: 'members',
                type: 'tuple',
            },
            { internalType: 'uint256', name: 'transferAmount', type: 'uint256' },
        ],
        name: 'transferVest',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '', type: 'address' }],
        name: 'userVest',
        outputs: [
            { internalType: 'uint192', name: 'amount', type: 'uint192' },
            { internalType: 'uint64', name: 'lastClaim', type: 'uint64' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'vestingDuration',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'voSPOOL',
        outputs: [{ internalType: 'contract IERC20Mintable', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
];
